import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

// The Connect GitHub popup (pages/GitHubConnect.jsx) announces on this channel when it's done.
export const GITHUB_CHANNEL = "crewbench-github";

// The company's GitHub connection (GET /api/github): {available, connection}. Refreshed when the popup
// finishes, in whichever tab is listening.
export function useGitHub() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["github"], queryFn: async () => (await api.get("/github")).data });
  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return undefined;
    const channel = new BroadcastChannel(GITHUB_CHANNEL);
    channel.onmessage = () => {
      qc.invalidateQueries({ queryKey: ["github"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
    };
    return () => channel.close();
  }, [qc]);
  return data || {};
}

// Opens the popup centred over this window; where popups are blocked, the flow runs in this tab.
export function connectGitHub() {
  const w = 1020, h = 760;
  const left = window.screenX + (window.outerWidth - w) / 2;
  const top = window.screenY + (window.outerHeight - h) / 2;
  const popup = window.open("/github/connect", "crewbench-github", `popup,width=${w},height=${h},left=${left},top=${top}`);
  if (!popup) window.location.assign("/github/connect");
}
